import { TokenConstants } from './constants'
import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'

const persistConfig = {
  key: 'easeon_token',
  storage,
}

function configurationLocal(state = {}, action) {
  switch (action.type) {
    case TokenConstants.SET_TOKEN_INFO:
      return {
        ...state,
        ...action.response,
      }

    case TokenConstants.SET_COUNTER_NUMBER:
      return {
        ...state,
        ...action.response,
      }
    case TokenConstants.SET_COUNTER_CATEGORY:
      return {
        ...state,
        ...action.response,
      }
    case TokenConstants.SET_MACHINE_ID:
      return {
        ...state,
        ...action.response,
      }
    default:
      return state
  }
}
export const tokens = (
  state = {
    displayTokens: null,
  },
  action
) => {
  switch (action.type) {
    case TokenConstants.SET_CURRENT_DISPLAY_TOKEN: {
      return {
        ...state,
        currentDisplayToken: { ...action.response },
        displayTokens:
          state.displayTokens &&
          state.displayTokens.map((token) => {
            if (token.url === action.response.url) {
              return action.response
            }
            return token
          }),
      }
    }
    case TokenConstants.SET_INITIAL_DISPLAY_TOKENS: {
      return {
        ...state,
        displayTokens: [...action.response],
      }
    }
    case TokenConstants.DELETE_TOKEN_INFO: {
      return {}
    }
    case TokenConstants.SET_AVG_SERVICE_TIME:
      return {
        ...state,
        avgServiceTime:action?.response?.average_service_time,
      }
    default:
      return state
  }
}

export const machineConfig = persistReducer(persistConfig, configurationLocal)
